<template>
  <!-- 联系我们页面容器 -->
  <div class="contact-container">
    <div class="page-header">
      <h1>联系我们</h1>
      <p>欢迎联系我们的各个分支机构，我们将为您提供专业的金融服务</p>
    </div>

    <!-- 搜索框 -->
    <!-- <div class="search-container">
      <el-input
        placeholder="请输入分支机构名称搜索"
        v-model="searchText"
        prefix-icon="el-icon-search"
        clearable
      ></el-input>
      <el-button type="primary" @click="search" icon="el-icon-search">搜索</el-button>
    </div> -->
    <!-- 地图展示 -->
    <baidu-map :center="center" :zoom="zoom" :scroll-wheel-zoom=true @ready="handler" class="bm-view" ak="aFkbX4f7G6uWGG5o0nGXySc5CbsYSTNZ">
      <bm-view style="width: 100%; height:400px; flex: 1"></bm-view>
      <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" :enableGeolocation=true></bm-navigation>
      <!-- <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" @locationSuccess="locationSuccess"></bm-geolocation> -->
      <bm-marker :position="center">
        <bm-info-window :show="true">我的位置</bm-info-window>
      </bm-marker>
      <bm-local-search :keyword="keyword" :auto-viewport="true" :location="location" :nearby="nearby" :forceLocal=true></bm-local-search>
    </baidu-map>
  </div>
</template>

<script>
import { getInfo } from "@/api";
import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
import BmView from 'vue-baidu-map/components/map/MapView.vue';
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue';
import BmInfoWindow from 'vue-baidu-map/components/overlays/InfoWindow.vue';
import BmNavigation from 'vue-baidu-map/components/controls/Navigation.vue';
import BmGeolocation from 'vue-baidu-map/components/controls/Geolocation.vue';
import bmLocalSearch from 'vue-baidu-map/components/search/LocalSearch.vue';
export default {
  name: "Contact", // 组件名称
  components: {
    BaiduMap,
    BmView,
    BmNavigation,
    BmGeolocation,
    bmLocalSearch,
    BmMarker,
    BmInfoWindow,
  },
  data() {
    return {
      searchText: "", // 搜索文本
      contactList: [], // 联系人列表数据
      map:null,
      center: {lng: 0, lat: 0},
      zoom: 3,
      location: '南阳',
      keyword: '农商银行',
      nearby:{
        center: {
          lng: 0, 
          lat: 0,
        },
        radius: 3000
      }
    };
  },
  computed: {
    // 计算属性：根据搜索文本过滤联系人列表
    filteredContactList() {
      if (!this.searchText) return this.contactList; // 如果没有搜索文本，返回全部列表
      // 根据名称或部门名称进行过滤
      return this.contactList.filter(
        (item) =>
          item.name.includes(this.searchText) ||
          item.department.includes(this.searchText)
      );
    },
  },
  methods: {
    // 设置表格行的类名，用于行样式
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 0) {
        return "header-row"; // 第一行使用header-row样式
      }
      return rowIndex % 2 === 0 ? "even-row" : "odd-row"; // 偶数行和奇数行使用不同样式
    },
    // 获取城市/分支机构列表数据
    getCityList() {
      // 调用API接口获取数据
      getInfo({
        model: "city", // 模型名称
        condition: {}, // 查询条件
        page: 1, // 页码
        pagesize: 20, // 每页条数
      }).then((res) => {
        if (res.status == 200) {
          this.contactList = res.data.data; // 设置联系人列表数据
          // 如果需要使用地图，取消下面注释并引入相应的地图SDK
          this.initMap();
        }
      });
    },
    handler ({BMap, map}) {
      this.map = map
      this.getCurrentLocation()
    },
    locationSuccess({point, AddressComponent, marker}){
      // console.log(point)
      // console.log(AddressComponent)
      // console.log(marker)
    },
    getCurrentLocation() {
      const geolocation = new BMap.Geolocation();
      let that = this
      geolocation.getCurrentPosition(function(result) {
        if (this.getStatus() === BMAP_STATUS_SUCCESS) {
          that.center = { lng: result.point.lng, lat: result.point.lat };
          that.nearby.center = { lng: result.point.lng, lat: result.point.lat };
          that.zoom = 10
          that.location = result.address.city

          // that.center = { lng: '112.590953', lat: '33.022236' };
          // that.nearby.center = { lng: '112.590953', lat: '33.022236' };
          // that.location = '南阳'

        } else {
          console.error('获取位置失败:', result.message);
          // 处理用户拒绝位置权限的情况
          if (result.status === BMAP_STATUS_PERMISSION_DENIED) {
            alert('位置服务不可用，请检查您的设备设置。');
          }
        }
      }, { enableHighAccuracy: true });
    },
    search(){
      this.keyword = this.searchText
    }
  },
  mounted() {
    this.getCityList(); // 获取城市/分支机构列表数据
  },
  // 组件创建时执行
  created() {},
};
</script>



<style scoped>

.contact-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  margin-bottom: 40px;
}

.page-header {
  text-align: center;
  margin-bottom: 30px;
  position: relative;
}

.page-header h1 {
  font-size: 32px;
  color: #333;
  margin-bottom: 40px;
  position: relative;
  display: inline-block;
}

.page-header h1:after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: linear-gradient(to right, #4e7cff, #21ab4b);
}

.page-header p {
  color: #666;
  font-size: 16px;
}

.search-container {
  margin-bottom: 20px;
  max-width: 400px;
}

.contact-table-container {
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 30px;
}

.branch-name,
.phone-number,
.address {
  display: flex;
  align-items: center;
}

.branch-name i,
.phone-number i,
.address i {
  margin-right: 8px;
  color: #21ab4b;
}

/* 表格行样式 */
.header-row {
  background-color: #f0f5ff !important;
}

.even-row {
  background-color: #fafafa;
}

.odd-row {
  background-color: #ffffff;
}

.el-table__row:hover {
  background-color: #f0f7ff !important;
}

.el-tag--primary {
  background-color: #ecf5ff;
  border-color: #d9ecff;
  color: #409eff;
}

.bm-view {
  width: 100%;
  margin-bottom: 20px;
}

</style>
